// extracted by mini-css-extract-plugin
export default {"toastContentWrapper":"Toast_toastContentWrapper__WgwJw","headerEllipsis":"Toast_headerEllipsis__16zUV"};